import React, { useEffect, useState } from "react";
import { Radio, Skeleton, Space} from "antd";
import { calculateDateRangeFromDate } from '../../../../../../../Utils/DateConverstion';
import { APIConstants } from '../../../../../../../Common/APIConstants';
import { useStoreUpdaterWithAPI } from '../../../../../../../Hooks/UseStoreUpdaterWithApi';
import TempMeters from "./TempMeters";
import { useSelector } from "react-redux";
import Empty from "../../../../../../CommonScreens/Empty";



const TempConvertorStatus = () => {
    const {loading, makeRequest } = useStoreUpdaterWithAPI();
    const [treeChartInput, setTreeChartInput] = useState("");
    const [meterData, setMeterData] = useState([]); 
     const [open, setOpen] = useState(false);
    const mode = useSelector((state) => state.darkMode);
    const { isdarkMode } = mode;
    console.log(isdarkMode)
  const [moduleList,setModuleList]=useState([
    { id: 3, name: 'Temperature' },
    { id: 6, name: 'Gas' },
    { id: 5, name: 'Air' },
    { id: 4, name: 'Water' },
    { id: 2, name: 'Steam' },
  ])
  const [module,setModule]=useState(3)
    const [selectedModule, setSelectedModule] = useState(3);
      useEffect(() => {
    makeRequest({
         type: APIConstants.GET,
         // GetFlowSteamGropeMeterDetails?GroupID=81
         url: `${APIConstants.FLOW_MODULES}`,
       }).then((res) => {
         console.log(res);
         if (res && res.length > 0) {
           setModuleList(res); 
         }
       });   
  }, []);

    const fetchConvertorStatus = (input) => {
        const currentDate = new Date();
        const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);
        console.log(from,to)
        makeRequest({
          type: APIConstants.GET,
          url: selectedModule==3?`${APIConstants.TEMP_CONVERTER_STATUS}?FromDate=${from}&ToDate=${to}`:`${APIConstants.FLOW_CONVERTER_STATUS}?ModuleType=${selectedModule}&FromDate=${from}&ToDate=${to}`,
        }).then((res) => {
          setMeterData(res);
          console.log(res);
        });
      };
    
      useEffect(() => {
        console.log(treeChartInput)
        fetchConvertorStatus(treeChartInput);

      }, [selectedModule]);

      // const setTreeChartInputString = () => {  
      //   // try {
    
      //   const currentDate = new Date();
      //   const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);
      //   console.log(from,to)
      //   const treeChartInputData = {
      //     FromDate: from,
      //     ToDate: to,
      //   };
      //   console.log(treeChartInputData);
    
      //   const finalInput = treeChartInputData;
      //   setTreeChartInput(finalInput);
    
      // };
    
      useEffect(() => {
        // setTreeChartInputString();
      }, []);

  return (
    <div>
       {
       
    <p className={` pb-2  ml-3 text-3xl dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>CONVERTER STATUS</p>
    }
    
     <div style={{ padding: 16 }}>

      <Radio.Group
        onChange={(e) => setSelectedModule(e.target.value)}
        value={selectedModule}
        optionType="button"
        buttonStyle="solid"
      >
        <Space wrap>
          {moduleList.map((module) => (
            <Radio.Button key={module.moduleId} value={module.moduleId}>
              {module.moduleName}
            </Radio.Button>
          ))}
        </Space>
      </Radio.Group>
    </div>
    <div className="flex justify-center">
    
      {loading  && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
      {
        //   isError && (
        // <div className="flex flex-col">
        //   <img className="w-[150px] h-[80px] "  />
        //   <p className="text-sm text-red-500 text-center">Server error</p>
        //   <p className="text-center">Please reload the page</p>
        // </div>
        //   )
      }
    </div>
   
    {meterData && !loading&& (
      <div className="flex flex-wrap gap-4">
        {meterData.map((item, index) => (
          <TempMeters key={index} item={item} />
        ))}
      </div>
    )}
    {loading&& !meterData &&(
        <div className={`${isdarkMode? '':''}`}>
                 <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
                </div>
    )}
  </div>
  )
}

export default TempConvertorStatus
